import { createAction, props } from '@ngrx/store';
import { LinehaulSchedule } from '@xpo-ltl/sdk-linehaulpayform';
import { ActionPatchData } from '../app.state';

export interface LinehaulScheduleAction {
  schedule?: LinehaulSchedule;
  schSequenceNbr?: string;
  patchData?: ActionPatchData;
}

export const addScheduleAction = createAction('[Schedules] Add Schedule', props<LinehaulScheduleAction>());

export const updateScheduleAction = createAction('[Schedules] Update Schedule', props<LinehaulScheduleAction>());

export const deleteScheduleAction = createAction('[Schedules] Delete Schedule', props<LinehaulScheduleAction>());

export const patchScheduleAction = createAction('[Schedules] Move Schedule', props<LinehaulScheduleAction>());
